import { BRACKET_DETAILS_ACTION } from "../../core/constants/Actions";
import { Action } from "../../core/models/ActionTypes";
import { Bracket } from "../../core/models/Bracket";
import { Tournament } from "../../core/models/Tournament";

const initialState: {
  brackets: Bracket | null;
  isLoading: boolean;
  tournament: Tournament | null;
} = {
  brackets: null,
  tournament: null,
  isLoading: false,
};

interface ActionType extends Action {
  payload: {
    brackets: Bracket;
    tournament: Tournament;
  };
}

export default function bracketDetailReducer(
  state = initialState,
  action: ActionType
) {
  switch (action.type) {
    case BRACKET_DETAILS_ACTION.REQUEST:
      return { ...state, isLoading: true };

    case BRACKET_DETAILS_ACTION.SUCCESS:
      const { brackets ,tournament} = action.payload;
      return { ...state, brackets, tournament, isLoading: false };

    case BRACKET_DETAILS_ACTION.FAILURE:
      return { ...state, ...initialState };

    default:
      return state;
  }
}
